module.exports = __webpack_public_path__ + "img/71.fcdaebc9.jpg";